import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Organization } from 'src/app/shared/models/organization.model';
import { SharedService } from 'src/app/shared/shared.service';
import { LidoFacilities, LidoFacilitiesService } from './lido-facilities.service';

@Component({
    selector: 'app-update-lido-facilities',
    templateUrl: './update-lido-facilities.component.html',
    styleUrls: ['./update-lido-facilities.component.css'],
    standalone: false
})
export class UpdateLidoFacilitiesComponent implements OnInit {

  public currentOrganizationId: number;
  public orgFacilities: LidoFacilities;

  private _organization: Organization;

  constructor(private _activatedRoute: ActivatedRoute, private _router: Router, private _lidoFacilitiesService: LidoFacilitiesService,
    private _sharedService: SharedService) { }

  ngOnInit(): void {
    const urlPramas = this._activatedRoute.snapshot.params;
    if (!urlPramas.orgId) {
      this._router.navigate(['/']);
    }
    // tslint:disable-next-line:radix
    if (parseInt(localStorage.getItem('orgId')) !== 1) {
      this._router.navigate(['/']);
    }
    this.currentOrganizationId = urlPramas.orgId;

    this._sharedService.getOrganization(urlPramas.orgId).subscribe(requestResult => {
      this._organization = requestResult;
      this._sharedService.organizationNameSubject.next({ 'de': this._organization.name_de, 'it': this._organization.name_it });
    }, requestError => {
      console.log(requestError);
    });

    this._lidoFacilitiesService.getLidoFacilitiesByOrgId(this.currentOrganizationId).subscribe(result => {
      console.log(result);
      this.orgFacilities = result;
    });
  }


  onFacilitieSwitchChange(facility: string, event: any) {
    this._lidoFacilitiesService.submitFacility(
      this.currentOrganizationId.toString(), facility, (event.target.checked ? 1 : 0)
    ).subscribe(result => {
      console.log(result);
    });
  }

}
